import ScrollTo from './lib/ScrollTo';

export default ScrollTo;
